"use client";

import { getImageURL, useSwiperSliderOptions } from "@/lib";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useRef, useState } from "react";
import { Button } from "@/components";

export const AboutPageTrustedClient = ({
  data = {},
  slug = "trusted_client",
}) => {
  const {
    short_description,
    description,
    thumbnail_image,
    title,
    video,
    button,
    icon_slider = [],
    youtube_embeded_url,
  } = data;

  if (
    !short_description &&
    !description &&
    !thumbnail_image?.src &&
    !title &&
    !video?.src &&
    !youtube_embeded_url &&
    !button &&
    (!icon_slider || icon_slider.length === 0)
  ) {
    return null;
  }

  const videoRef = useRef();
  const [isPlaying, setIsPlaying] = useState(false);

  const handleVideoClick = () => {
    if (!videoRef.current) return;
    if (!isPlaying) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  const handleEnded = () => {
    setIsPlaying(false);
  };

  const { options } = useSwiperSliderOptions({
    slidesPerView: 6,
    modules: [Autoplay],
    spaceBetween: 25,
    loop: true,
    speed: 4000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    freeMode: {
      enabled: true,
    },
    breakpoints: {
      240: {
        slidesPerView: 1.1,
      },
      600: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 5,
      },
      1200: {
        slidesPerView: 6,
      },
    },
  });

  return (
    <>
      <section className="trusted__section" id={slug}>
        <div className="custom-container">
          <div className="row">
            <div className="col-12">
              <div className="trusted__bg_wrapper">
                <div className="section_bg" />
                <div className="row align-items-end">
                  {(video?.src && thumbnail_image?.src) ||
                  youtube_embeded_url ||
                  short_description ? (
                    <div className="col-12 col-md-6 col-lg-6">
                      <div className="trusted__video">
                        {video?.src && thumbnail_image?.src && (
                          <div className="video__area">
                            <div
                              className="video__container"
                              onClick={handleVideoClick}
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              <div className="video__overlay" />
                              <video
                                ref={videoRef}
                                id="video-trusted"
                                playsInline
                                poster={getImageURL(thumbnail_image?.src)}
                                width="100%"
                                height="auto"
                                onEnded={handleEnded}
                                controls={false}
                                onPlay={() => setIsPlaying(true)}
                                onPause={() => setIsPlaying(false)}
                              >
                                <source
                                  src={getImageURL(video?.src)}
                                  type="video/mp4"
                                />
                                Your browser does not support the video tag.
                              </video>
                              {!isPlaying && (
                                <a
                                  type="button"
                                  className="play__btn_wrap"
                                  aria-label="Play Video"
                                  href="#!"
                                  onClick={(e) => e.preventDefault()}
                                >
                                  <svg
                                    width={138}
                                    height={138}
                                    viewBox="0 0 138 138"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <circle
                                      opacity="0.25"
                                      cx={69}
                                      cy={69}
                                      r={69}
                                      fill="white"
                                    />
                                    <circle
                                      opacity="0.5"
                                      cx={69}
                                      cy={69}
                                      r={49}
                                      fill="white"
                                    />
                                    <circle
                                      cx={69}
                                      cy={69}
                                      r={28}
                                      fill="white"
                                    />
                                    <path
                                      d="M84 69L60.75 81.9904L60.75 56.0096L84 69Z"
                                      fill="#0DB02B"
                                    />
                                  </svg>
                                </a>
                              )}
                            </div>
                          </div>
                        )}
                        {/* Youtube embed if no video */}
                        {!video?.src && youtube_embeded_url && (
                          <div className="video__area">
                            <div
                              className="video__container"
                              style={{
                                position: "relative",
                                paddingBottom: "56.25%",
                                height: 0,
                                overflow: "hidden",
                              }}
                            >
                              <iframe
                                src={youtube_embeded_url}
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                }}
                              ></iframe>
                            </div>
                          </div>
                        )}
                      </div>
                      {short_description && (
                        <div className="trusted__content">
                          <div className="content__wrap text-center">
                            <p
                              dangerouslySetInnerHTML={{
                                __html: short_description,
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  ) : null}
                  {(title ||
                    description ||
                    (button &&
                      button?.title &&
                      (button?.url || button?.external_url))) && (
                    <div className="col-12 col-md-6 col-lg-6 trusted_col">
                      <div className="trusted__area">
                        {title && (
                          <div className="section_header">
                            <h4
                              className="heading fs-48 fw-300"
                              dangerouslySetInnerHTML={{
                                __html: title,
                              }}
                            />
                          </div>
                        )}
                        {description && (
                          <div className="content__wrap">
                            <p
                              dangerouslySetInnerHTML={{
                                __html: description,
                              }}
                            />
                          </div>
                        )}
                        {button &&
                          button?.title &&
                          (button?.url || button?.external_url) && (
                            <Button
                              label={button?.title}
                              href={
                                button?.url_type === "external"
                                  ? button?.external_url
                                  : button?.url
                              }
                            />
                          )}
                      </div>
                    </div>
                  )}
                </div>
                {/* Client slider */}
                {icon_slider && icon_slider.length > 0 && (
                  <div className="row">
                    <div className="col-12">
                      <div className="trusted__client">
                        <div className="trusted__slider swiper">
                          <Swiper {...options}>
                            {icon_slider.map(
                              (item, idx) =>
                                item?.icon?.src && (
                                  <SwiperSlide key={idx}>
                                    <img
                                      className="img-fluid"
                                      src={getImageURL(item.icon?.src)}
                                      alt={item.icon?.alt || ""}
                                    />
                                  </SwiperSlide>
                                )
                            )}
                          </Swiper>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
